import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../../atoms/table';
import type { TableBlock } from '../chat-content';

export function TableBlockRenderer({ block }: { block: TableBlock }) {
  return (
    <div className="overflow-hidden rounded-lg border border-border text-sm">
      <Table>
        <TableHeader>
          <TableRow>
            {block.headers.map((h) => (
              <TableHead key={h} className="whitespace-nowrap">
                {h}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {block.rows.map((row, i) => (
            <TableRow key={i}>
              {row.map((cell, j) => (
                <TableCell key={j}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
